import { Star, ArrowUpRight, Quote, BadgeCheck } from "lucide-react";
import { Reveal, PageHero, CTAButton } from "@/components/bits";
import { BRANCHES, GOOGLE_REVIEWS, waLink } from "@/data/site";
import { MessageCircle } from "lucide-react";

const GoogleMark = () => (
  <span
    className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-white/15 bg-white text-base font-black text-[#4285F4]"
    aria-hidden="true"
  >
    G
  </span>
);

const Reviews = () => (
  <>
    <PageHero
      eyebrow="Reviews"
      title={<>What our students &amp; <span className="text-red-500">families say</span></>}
      sub="Genuine reviews from our Google Business Profile — published exactly as written by students and parents. No scripts, no edits."
    />

    <section className="mx-auto max-w-[1440px] px-5 pb-24 sm:px-8" data-testid="reviews-section">
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        {GOOGLE_REVIEWS.map((r, i) => (
          <Reveal key={i} delay={(i % 2) * 0.08}>
            <article className="card-glow flex h-full flex-col border border-white/10 bg-[#0F0F14] p-8" data-testid={`review-card-${i}`}>
              <Quote size={22} className="text-red-600" aria-hidden="true" />
              {r.title && (
                <h3 className="mt-4 font-display text-base font-extrabold uppercase tracking-wide text-white">
                  {r.title}
                </h3>
              )}
              <p className="mt-4 flex-1 text-sm leading-relaxed text-zinc-300">“{r.text}”</p>
              <footer className="mt-6 flex items-center gap-3 border-t border-white/10 pt-5">
                <GoogleMark />
                <div>
                  <p className="flex items-center gap-1.5 text-[13px] font-semibold text-white">
                    {r.name} <BadgeCheck size={14} className="text-red-500" aria-hidden="true" />
                  </p>
                  <p className="font-mono2 text-[9px] uppercase tracking-[0.2em] text-zinc-500">
                    Verified Google Review
                  </p>
                </div>
              </footer>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-12 text-center">
        <CTAButton href={BRANCHES[0].maps} testid="reviews-view-all-btn">
          <Star size={15} /> View All Google Reviews <ArrowUpRight size={15} />
        </CTAButton>
      </Reveal>

      <Reveal className="mt-20 border border-white/10 bg-[#08080B] p-10 text-center sm:p-14">
        <p className="font-display text-xl font-black uppercase tracking-tight text-zinc-200 sm:text-2xl">
          Trained with us? <span className="text-red-500">Your words matter.</span>
        </p>
        <p className="mx-auto mt-4 max-w-md text-sm text-zinc-400">
          Share your experience on our Google profile — it helps other families find the right academy.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <CTAButton href={BRANCHES[0].maps} variant="ghost" testid="reviews-write-btn">Write a Review on Google</CTAButton>
          <CTAButton href={waLink()} variant="whatsapp" testid="reviews-whatsapp-btn">
            <MessageCircle size={15} /> WhatsApp Us
          </CTAButton>
        </div>
      </Reveal>
    </section>
  </>
);

export default Reviews;
